import { Component, OnInit, ViewChild, ElementRef, Input, AfterViewInit } from '@angular/core';

import { GUIService } from '../../gui.service';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { ThemeService, Helpers } from 'ngx-elvis-ds';
import { BasePage } from 'ngx-elvis-ds';
import { DomController, IonContent } from '@ionic/angular';
import { I18NService } from 'src/app/services/i18n.service';

export class MaintenanceDialogCommands {
  public static OPEN = ['MAINTENANCE'];
  public static UPDATE = [];
  public static CLOSE = ['MAINTENANCE_CLOSE'];
}

@Component({
  selector: 'app-maintenance-dialog',
  templateUrl: './maintenance-dialog.page.html',
  styleUrls: ['./maintenance-dialog.page.scss'],
})
export class MaintenanceDialogPage extends BasePage implements OnInit, AfterViewInit {

  @ViewChild('mntDialog', { static: true }) mntDialog: ElementRef;
  @Input() data: any;

  cashTotal: number = 0;
  mntContent: any;

  constructor(
    public i18nSvc: I18NService,
    public configSvc: ConfigService,
    public themeSvc: ThemeService,
    public guiSvc: GUIService,
    private sam: SAMService,
    private domCtrl: DomController
  ) {
    super();
  }

  ngOnInit() {
    this.domCtrl.read(() => {
      this.mntContent = document.querySelector('ion-content#mnt-content');
    });
  }

  ngAfterViewInit() {
    this.domCtrl.write(() => {
      Helpers.hideScrollbars(this.mntContent);
    });
  }

  ionViewWillEnter() {
    this.guiSvc.initLocalKeyboard('maintenanceForm', '#maintenance-keypad-host', false, true, 'maintenance-keypad');
  }

  ionViewDidEnter() {
  }

  updateTotal() {
    this.cashTotal = 0;

    for (const input of this.data.Inputs) {
      const value = Math.max(0, input.Val);
      const hiddenVal = Math.max(0, input.HiddenVal);
      if (input.Val !== '' && input.Val !== undefined) {
        this.cashTotal += hiddenVal * value;
      }
    }

    this.cashTotal = this.cashTotal / this.configSvc.currency.divider;
  }

  updatePartialTotal(input: any) {
    setTimeout(() => {
      if (input.LabelAfter !== 'null') {
        try {
          if (input.Val !== '' && input.Val !== NaN && input.Val !== 'NaN' && input.Val !== undefined) {
            input.partialTotal = parseInt(input.Val, 10) * parseInt(input.HiddenVal, 10) / this.configSvc.currency.divider;
          } else {
            input.partialTotal = 0;
          }
        } catch (error) {
          input.partialTotal = 0;
        }
      }
      this.updateTotal();
    }, 50)
  }

  deleteCallback() {
    this.sam.onSend({
      Command: 'GENERIC_INPUT',
      Callback: this.data.DelCallback,
    });
  }

  onCallback(success = false) {
    const inputResponse = [];

    for (const input of this.data.Inputs) {
      inputResponse.push({
        id: String(input.Id),
        fieldType: String(input.Type),
        dbField: String(input.Dbfieldname),
        value: String(input.Val || 0),
        hiddenVal: String(input.HiddenVal)
      });
    }

    if (success) {
      this.successCallback(inputResponse);
    } else {
      this.failureCallback(inputResponse);
    }
  }

  // private

  private successCallback(inputResponse) {
    this.sam.onSend({
      Command: 'GENERIC_INPUT',
      Callback: this.data.Callbackconfirm,
      parms: {
        InputData: inputResponse
      }
    });
  }

  private failureCallback(inputResponse) {
    this.sam.onSend({
      Command: 'GENERIC_INPUT',
      Callback: this.data.Callbackabort,
      parms: {
        InputData: inputResponse
      }
    });
  }
}
